<template>
    <div class="modal fade" id="cancel-contract-modal" role="dialog" @click="$emit('close')">
      <div class="modal-dialog" @click.stop>
        <div class="modal-content">
          <div class="modal-header bg-color-info">
            <button type="button" class="close close-btn" data-dismiss="modal" @click="$emit('close')"> &times;</button>
          </div>
          <div class="modal-body">
            <p>プレミアムを解約してもよろしいですか？</p>
            <div>
              <div class="notes">ご注意事項</div>
              <div class="m-l-sm notes-content">
                ・ 決済が完了している利用料について、日割りでの精算・返金は行いません。<br>
                ・ セルモン倉庫をご利用の場合は、同時に利用を停止させていただきます。<br>
                ・ セルモン倉庫に在庫がある場合、セラー様へ着払いにてご送付させていただきます。
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-cancel text-white" data-dismiss="modal" @click="$emit('confirm')">解約する</button>
            <button type="button" class="btn" data-dismiss="modal" @click="$emit('close')">キャンセル</button>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
export default {
  mounted () {
    $('#cancel-contract-modal').modal('show')
    $('#cancel-contract-modal').on('hidden.bs.modal', (e) => {
      if (!$('#myModal').length) {
        $('body').attr({
          style: 'padding-right: 0px !important; overflow: unset !important'
        })
      } else {
        $('body').attr('style', 'overflow: hidden !important')
      }
    })
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  }
}
</script>
<style scoped>
  .btn-cancel {
    background-color: #a6a6a6;
    width: 150px;
  }
  @media (min-width:768px) {
    .modal-dialog {
      width: 730px;
    }
  }
  #cancel-contract-modal .notes {
    color: #ff0000;
    font-weight: bold;
  }
  #cancel-contract-modal .notes-content {
    color: #ff0000;
    font-weight: bold;
  }
  @media (min-width: 992px) and (max-width: 1200px) {
    #cancel-contract-modal .modal-dialog {
      width: 730px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/setting/CancelContractModal.vue